import { useFormikContext } from 'formik';
import React, { useContext, useRef } from 'react';
import { useFormContext } from './FormContext';
import { SubmitFormRelation } from './FormContext.types';

interface FormActions {
  submitForm: (relation?: SubmitFormRelation) => void
  submitFormikForm: () => Promise<unknown>
}

const FormActionsContext = React.createContext<FormActions | undefined>(undefined);

export const FormActionsProvider: React.FC = ({ children }) => {
  const { submitForm } = useFormContext();
  const formik = useFormikContext();
  const latest = useRef({ submitForm, formik });
  latest.current = { submitForm, formik };

  // Stable actions and children isolate field rendering from Formik updates,
  // while existing autosave reactions still call the latest form handlers.
  const actions = useRef<FormActions>({
    submitForm: (relation) => latest.current.submitForm(relation),
    submitFormikForm: async () => await latest.current.formik.submitForm(),
  });

  return <FormActionsContext.Provider value={actions.current}>{children}</FormActionsContext.Provider>;
};

export const useFormActions = (): FormActions => {
  const actions = useContext(FormActionsContext);
  if (!actions) {
    throw new Error('FormActionsProvider is missing');
  }
  return actions;
};
